import imageCompression from 'browser-image-compression';

export const compressImage = async (file: File, maxSizeMB: number = 1): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = async () => {
      const targetWidth = img.width;
      const targetHeight = img.height;
      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error("Impossible d'obtenir le contexte du canvas"));

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, targetWidth, targetHeight);

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      canvas.toBlob(async (blob) => {
        if (!blob) return reject(new Error("Échec de la conversion du canvas en blob"));

        const resizedFile = new File([blob], file.name, { type: 'image/jpeg' });

        try {
          if (resizedFile.size > maxSizeMB * 1024 * 1024) {
            const compressedFile = await imageCompression(resizedFile, {
              maxSizeMB,
              maxWidthOrHeight: targetWidth,
              useWebWorker: true,
            });
            resolve(compressedFile);
          } else {
            resolve(resizedFile);
          }
        } catch (compressionError) {
          console.error("Erreur lors de la compression :", compressionError);
          resolve(resizedFile);
        }
      }, 'image/jpeg', 0.9);
    };

    img.onerror = () => reject(new Error("Impossible de charger l'image"));
    img.src = URL.createObjectURL(file);
  });
};

// Standardise à 360x360 pour les images trop grandes seulement
export const standardizeImageDimensions = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = async () => {
      const targetWidth = 360;
      const targetHeight = 360;

      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error("Impossible d'obtenir le contexte du canvas"));

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, targetWidth, targetHeight);

      const ratio = Math.min(targetWidth / img.width, targetHeight / img.height);
      const newWidth = img.width * ratio;
      const newHeight = img.height * ratio;
      const offsetX = (targetWidth - newWidth) / 2;
      const offsetY = (targetHeight - newHeight) / 2;

      ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);

      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Échec de la conversion du canvas en blob"));
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        const mimeType = fileExtension === 'png' ? 'image/png' : 'image/jpeg';
        const standardizedFile = new File([blob], file.name, { type: mimeType });
        resolve(standardizedFile);
      }, file.type);
    };

    img.onerror = () => reject(new Error("Impossible de charger l'image"));
    img.src = URL.createObjectURL(file);
  });
};